import React, { Component } from 'react';
import { Phone, AlertTriangle, Info, BookOpen } from 'lucide-react';
export function TrailerHitchInfoPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7172">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7173">
        <div className="container mx-auto px-4" data-id="element-7174">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7175">
            Trailer Hitch Information
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7176">
            Complete Guide to Safe Towing Systems
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7177">
        <div className="max-w-4xl mx-auto" data-id="element-7178">
          {/* Safe Towing System */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7179">
            <div className="flex items-start mb-6" data-id="element-7180">
              <AlertTriangle className="text-[#B1050B] mr-4 flex-shrink-0 mt-1" size={32} data-id="element-7181" />
              <div data-id="element-7182">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-7183">
                  Safe Towing System Requirements
                </h2>
                <p className="text-lg text-gray-700 mb-4" data-id="element-7184">
                  A Safe Towing System requires that your vehicle and receiver
                  hitch match or exceed the needs of your trailer.
                </p>
                <p className="text-lg text-gray-700 mb-4" data-id="element-7185">
                  The Intermediate Towing Components must also meet the overall
                  ratings of your Towing System.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-7186">
                  <strong data-id="element-7187">Example:</strong> ballmounts, hitchballs and safety
                  chains.
                </p>
                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-7188">
                  <p className="text-gray-800" data-id="element-7189">
                    <strong data-id="element-7190">IMPORTANT:</strong> Check your vehicle and trailer
                    User's Manual for helpful information about their
                    capabilities and limitations.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Glossary Header */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-md p-6 mb-8 text-center" data-id="element-7191">
            <h2 className="text-3xl font-bold flex items-center justify-center" data-id="element-7192">
              <BookOpen className="mr-3" size={32} data-id="element-7193" />
              GLOSSARY - Terms, Tips and Specifications
            </h2>
          </div>

          {/* Ball (Hitch Ball) */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7194">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7195">
              <Info className="mr-2 text-blue-600" size={24} data-id="element-7196" />
              Ball (Hitch Ball)
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-7197">
              The Hitch Ball is the connection from the hitch to the trailer.
              There are many elements in determining the correct hitch ball.
              Mounting platform thickness, hole size, coupler socket size and
              the most important gross trailer weight rating.
            </p>
            <div className="bg-blue-50 rounded-lg p-4 mb-4" data-id="element-7198">
              <p className="text-gray-700 mb-2" data-id="element-7199">
                <strong data-id="element-7200">Requirements:</strong>
              </p>
              <ul className="list-disc list-inside space-y-1 text-gray-700" data-id="element-7201">
                <li data-id="element-7202">Platform must be at least 3/8" thick</li>
                <li data-id="element-7203">
                  Hole size must not be more than 1/16 of an inch larger in
                  diameter than the threaded shank
                </li>
                <li data-id="element-7204">
                  Every time you tow be sure to check the nut and lock washer to
                  make sure it is fastened securely
                </li>
              </ul>
            </div>
            <p className="text-gray-700 font-semibold" data-id="element-7205">
              A = Ball Diameter | B = Shank Diameter | C = Shank Length
            </p>
          </div>

          {/* Ball Mount */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7206">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7207">
              <Info className="mr-2 text-blue-600" size={24} data-id="element-7208" />
              Ball Mount
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-7209">
              The ball mount is placed inside the hitch opening which is mounted
              to the vehicle. Be sure to check your ball mount before towing to
              make sure a hitch pin is placed through the hole of the ball
              mount. The hitch pin secures the ball mount inside the tube of the
              receiver hitch when towing.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-7210">
              <div className="bg-green-50 rounded-lg p-4" data-id="element-7211">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-7212">
                  Style Type #1 Ball mount:
                </h4>
                <p className="text-gray-700" data-id="element-7213">
                  This style of ball mount is needed when the trailer and
                  vehicle are equally level.
                </p>
              </div>

              <div className="bg-purple-50 rounded-lg p-4" data-id="element-7214">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-7215">
                  Style Type #2 Ball mount:
                </h4>
                <p className="text-gray-700" data-id="element-7216">
                  This style of ball mount is needed when your trailer and
                  vehicle are NOT equally level.
                </p>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-7217">
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-7218">
                How do I determine what size drop or rise I need for my ball
                mount?
              </h4>
              <p className="text-gray-700 mb-2" data-id="element-7219">
                To determine the size drop or rise for your style type #2 ball
                mount: (style type #1 is only for equal level vehicle and
                trailer)
              </p>
              <ol className="list-decimal list-inside space-y-1 text-gray-700" data-id="element-7220">
                <li data-id="element-7221">
                  First level your trailer and measure from the ground up to the
                  top ID. of receiver tube opening
                </li>
                <li data-id="element-7222">
                  Second, measure your vehicle from the ground up to the bottom
                  of the trailer coupler
                </li>
                <li data-id="element-7223">
                  Third take the difference from both measurements and this will
                  determine the size of drop or rise you need
                </li>
              </ol>
            </div>
          </div>

          {/* Coupler */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7224">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7225">
              <Info className="mr-2 text-blue-600" size={24} data-id="element-7226" />
              Coupler
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-7227">
              The coupler is the component that is placed over the hitch ball
              that connects the vehicle to the trailer. Be sure that the coupler
              size matches the size of the hitch ball and that the coupler
              handle is securely fastened.
            </p>
            <p className="text-gray-700 font-semibold" data-id="element-7228">
              To determine what size hitch ball you need for your application
              you will need to know the size of coupler that is on the trailer.
            </p>
          </div>

          {/* Gross Trailer Weight */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7229">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7230">
              <Info className="mr-2 text-blue-600" size={24} data-id="element-7231" />
              Gross Trailer Weight (GTW)
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-7232">
              The Gross Trailer Weight (GTW) is a combination of the weight of
              the trailer and cargo inside. This is the total weight of both
              elements.
            </p>
            <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4" data-id="element-7233">
              <p className="text-red-900 font-bold" data-id="element-7234">
                Never exceed the weight capacity (GTW) of your trailer hitch.
              </p>
            </div>
          </div>

          {/* Hitch Classes */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7235">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7236">
              <Info className="mr-2 text-blue-600" size={24} data-id="element-7237" />
              Hitch, Receiver Hitch, Trailer Hitch
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-7238">
              A Receiver Hitch is the primary device that is attached to the
              rear of the vehicle that allows you to tow. There are six classes
              of hitches. It is very important to choose the correct class of
              receiver hitch. Gross trailer weight and tongue weight will
              determine the hitch that is needed.
            </p>
            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mb-6" data-id="element-7239">
              <p className="text-gray-800 font-bold" data-id="element-7240">
                Do not exceed the lowest rating of any component of your towing
                system.
              </p>
            </div>

            <div className="space-y-3" data-id="element-7241">
              <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-blue-500" data-id="element-7242">
                <p className="font-bold text-gray-900" data-id="element-7243">Class 1</p>
                <p className="text-gray-700" data-id="element-7244">up to 2000 lbs. GTW</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-green-500" data-id="element-7245">
                <p className="font-bold text-gray-900" data-id="element-7246">Class 2</p>
                <p className="text-gray-700" data-id="element-7247">3500 lbs. GTW</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-yellow-500" data-id="element-7248">
                <p className="font-bold text-gray-900" data-id="element-7249">Class 2.5</p>
                <p className="text-gray-700" data-id="element-7250">4,000 lbs. GTW</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-orange-500" data-id="element-7251">
                <p className="font-bold text-gray-900" data-id="element-7252">Class 3</p>
                <p className="text-gray-700" data-id="element-7253">10,000 lbs WD - 5,000 lbs. WC</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-red-500" data-id="element-7254">
                <p className="font-bold text-gray-900" data-id="element-7255">Class 4</p>
                <p className="text-gray-700" data-id="element-7256">12,000 lbs. WD - 10,000 lbs. WC</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-purple-500" data-id="element-7257">
                <p className="font-bold text-gray-900" data-id="element-7258">Class 5</p>
                <p className="text-gray-700" data-id="element-7259">14,000 lbs. WD - 12,000 lbs. WC</p>
              </div>
            </div>
          </div>

          {/* Safety Chains */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7260">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7261">
              <AlertTriangle className="mr-2 text-red-600" size={24} data-id="element-7262" />
              Safety Chains
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-7263">
              Safety chains are a requirement and should be crossed under the
              tongue of the trailer so that the tongue will not drop to the road
              if it becomes separated from the hitch.
            </p>

            <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6" data-id="element-7264">
              <p className="text-gray-800 font-bold mb-2" data-id="element-7265">
                Important Safety Rules:
              </p>
              <ul className="list-disc list-inside space-y-1 text-gray-700" data-id="element-7266">
                <li data-id="element-7267">Always leave enough slack so you can turn</li>
                <li data-id="element-7268">Never allow the safety chains to drag on the ground</li>
                <li data-id="element-7269">Never attach the safety chains to the bumper</li>
              </ul>
            </div>

            <h4 className="font-bold text-gray-900 mb-3" data-id="element-7270">
              Trailer Classification: Safety Chain Breaking Force-Minimum
            </h4>
            <div className="space-y-2" data-id="element-7271">
              <div className="bg-gray-50 rounded p-3" data-id="element-7272">
                <span className="font-semibold" data-id="element-7273">Class 1:</span> 2000 lbs (8.9
                kN)
              </div>
              <div className="bg-gray-50 rounded p-3" data-id="element-7274">
                <span className="font-semibold" data-id="element-7275">Class 2:</span> 3500 lbs (15.6
                kN)
              </div>
              <div className="bg-gray-50 rounded p-3" data-id="element-7276">
                <span className="font-semibold" data-id="element-7277">Class 3:</span> 5000 lbs (22.2
                kN)
              </div>
              <div className="bg-gray-50 rounded p-3" data-id="element-7278">
                <span className="font-semibold" data-id="element-7279">Class 4:</span> The strength
                rating of each length of safety chain or its equivalent and its
                attachments shall be equal to or exceed in minimum breaking
                force the GVWR (Gross Vehicle Weight Rating) of the trailer.
              </div>
            </div>
          </div>

          {/* Sway Control */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7280">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7281">
              <Info className="mr-2 text-blue-600" size={24} data-id="element-7282" />
              Sway Control
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-7283">
              The Sway Control is a device used to reduce the lateral movements
              of the trailer that are caused by the wind. This works along with
              a weight distribution hitch.
            </p>
            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-7284">
              <p className="text-gray-800 font-semibold" data-id="element-7285">
                Do not use this on a class 1, 2 or 2.5 hitch or with surge
                brakes.
              </p>
            </div>
          </div>

          {/* Tongue Weight */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7286">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7287">
              <Info className="mr-2 text-blue-600" size={24} data-id="element-7288" />
              Tongue Weight (TW)
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-7289">
              Tongue weight is the downward force that is exerted on the hitch
              ball by the coupler. Tongue weight will vary depending on where
              the load is positioned in relationship to the trailer axle(s).
            </p>
            <div className="bg-blue-50 rounded-lg p-4" data-id="element-7290">
              <p className="text-gray-800 mb-2" data-id="element-7291">
                <strong data-id="element-7292">How to Measure Tongue Weight:</strong>
              </p>
              <p className="text-gray-700 mb-2" data-id="element-7293">
                To measure the tongue weight, use either a commercial scale or a
                bathroom scale with the coupler at towing height.
              </p>
              <p className="text-gray-700" data-id="element-7294">
                When using a bathroom scale with heavier tongue weights, use the
                method shown; multiplying (the scale reading x 3).
              </p>
            </div>
          </div>

          {/* Weight Distribution */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7295">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-7296">
              <Info className="mr-2 text-blue-600" size={24} data-id="element-7297" />
              Weight Distribution (WD)
            </h3>
            <p className="text-gray-700" data-id="element-7298">
              A Weight Distribution hitch is used to balance the weight of the
              cargo between the front and rear wheels throughout the trailer
              which will allow for better steering, braking, and level riding.
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7299">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7300">
              Need Help with Trailer Hitch Installation or Service?
            </h2>
            <p className="text-xl mb-6" data-id="element-7301">
              Expert advice and professional installation services
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7302">
              <Phone className="mr-3" size={24} data-id="element-7303" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7304">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}